import { render, staticRenderFns } from "./CartaoOrdemDePagamento.vue?vue&type=template&id=be073c6c&scoped=true"
import script from "./CartaoOrdemDePagamento.vue?vue&type=script&setup=true&lang=js"
export * from "./CartaoOrdemDePagamento.vue?vue&type=script&setup=true&lang=js"
import style0 from "./CartaoOrdemDePagamento.vue?vue&type=style&index=0&id=be073c6c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be073c6c",
  null
  
)

export default component.exports